import {ObjUtil} from 'yougile-util'

export const COLUMN_NAMES_CORRECT = {
  PROJECT: 'Project',
  TITLE: 'Title',
  START_DATE: 'Start Date',
  BOARD: 'Board',
  COLUMN: 'Column',
  PARENT_TASK: 'Parent Task',
  DESCRIPTION: 'Description',
  COMPLETED: 'Completed',
  CREATED_DATE: 'Created Date',
  ARCHIVED: 'Archived',
  DEADLINE: 'Deadline',
  ASSIGNED: 'Assigned'
}

export const COLUMN_NAMES = ObjUtil.map(COLUMN_NAMES_CORRECT, (_, v) =>
  v.toLowerCase()
)

export const SHEET_NAME = 'Sheet1'
